export default __webpack_public_path__ + "static/media/7. Zayavlenie na zapros micropreparata.5d4f9779.pdf";